import { Stack, Typography } from "@mui/material";
import { useUnitsFormatter } from "hooks/formatters";
import { useOverrideMixMaterials } from "./useOverrideMixMaterials";
import { MixRead } from "src/store/api/generatedApi";
import { useFormatNumber } from "src/utils/formatNumber";

export const OverrideMixDetails = ({
  title,
  mix,
}: {
  title: string;
  mix: MixRead;
}) => {
  const { ratioMaterials, additions } = useOverrideMixMaterials(mix);
  const format = useFormatNumber()(3);
  const units = useUnitsFormatter(false);
  return (
    <Stack
      sx={{
        flex: 1,
        minWidth: 0,
        gap: 1,
        border: 1,
        borderColor: "grey.300",
        borderRadius: 1,
        p: 2,
      }}
    >
      <Typography variant="h6">{title}</Typography>
      {ratioMaterials.length > 0 && (
        <Typography variant="body2Mono">
          {ratioMaterials.map((material) => material.materialName).join(":")}
          {" — "}
          {ratioMaterials
            .map((material) => format(material.totalMass))
            .join(":")}
        </Typography>
      )}
      {additions.map((material) => (
        <Typography key={material.materialName} variant="body2Mono">
          {"+"}
          {format(material.totalMass)}
          {material.unit === "mass" ? units("mass") : ""}{" "}
          {material.materialName}
        </Typography>
      ))}
    </Stack>
  );
};
